import React, { useCallback } from 'react';
import { useNavigate } from 'js/hooks/navigate';
import { clsx } from 'js/utils/classNames.util';

import * as Types from './types';
import * as constants from './constants';

import style from './Button.scss';

export const Button: React.FC<Types.IButtonProps> = ({
    href,
    onClick,
    children,
    className,
    type = 'button',
    size = constants.SIZES.medium,
    view = constants.VIEWS.primary,
    color = constants.COLORS.success,
    ...props
}) => {
    const navigate = useNavigate();
    const { VIEWS, COLORS, SIZES } = constants;

    const classNames = clsx([
        className,
        style.button,
        style[SIZES[size]],
        style[VIEWS[view]],
        style[COLORS[color]]
    ]);

    const onButtonClick = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        onClick && onClick(event);

        href && navigate(href);
    }, [href, navigate, onClick]);

    return (
        <button
            type={type}
            className={classNames}
            onClick={onButtonClick}
            {...props}
        >
            {children}
        </button>
    );
};
